module.exports = __webpack_public_path__ + "b6feedcb0b10a408563cee5862714f9d.pdf";